import React, {ReactElement, FC, useEffect, useState} from "react";
import { RouteComponentProps, Link } from "react-router-dom";
import { withRouter, useHistory, useLocation } from "react-router";
import {
    Box,
    Dialog,
    DialogTitle,
    IconButton,
    DialogContent,
    Button,
    Menu,
    MenuItem,
    Typography
} from "@material-ui/core";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { ITab } from "../../../utils/interfaces";
import { TabItems } from "./TabItems";
import {colorSecondary, colorWhite} from "../../../constants/theme";
import {useSelector} from "react-redux";
import {RootState, useAppDispatch} from "../../../redux/store";
import {logOutUser, getUserByID} from "../../../redux/user/user.actions";
import {getCreditRequestsCount} from "../../../redux/credits/credits.actions";
import {setIsLogOut} from "../../../redux/common/common.reducers";
import API from "../../../helpers/apiHelpers";

const useStyle = makeStyles((theme: Theme) => ({
    rootTab: {
        minWidth: "auto",
        display: "flex",
        fontWeight: "bold",
        fontSize: "20px",
        lineHeight: "26px",
        color: "#273878", 
        fontFamily: "Bogart Regular",
        padding: 0,
        margin: 0,
        marginLeft: 15,
        textDecoration: "none",
        paddingTop: "3px"
    },
    submitButton: {
        // background: "#65CCCE",
        // color: "#273878",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        borderRadius: "5px",
        border: "none",
        height: "30px",
        marginLeft: 10,
        marginRight: 5,
    },
    rootTabs: {
        display: "flex",
        [theme.breakpoints.down("sm")]: {
            display: "none",
        }
    },
    selected: {
        color: "#00007A"
    },
    creditsMenu: {
        padding: "0",
        border: "1px solid #CCCDE5",
        borderRadius: "5px"
    },
    creditsMenuText: {
        fontSize: "12px"
    },
    creditsMenuTextBold: {
        fontSize: "12px",
        fontWeight: "bold"
    }
}));

const MenuLogo = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const history = useHistory();
    const classes = useStyle();
    const creditsAvailable = useSelector((state: RootState) => state?.credits.creditsAmount);
    const creditsRedux = useSelector((state: RootState) => state?.credits);
    const user = useSelector((state: RootState) => state?.user);
    const dispatch = useAppDispatch();

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (url) => {
        history.push(url);
        setAnchorEl(null);
    };

    useEffect(() => {
        dispatch(getCreditRequestsCount());
    }, []);

    useEffect(() => {
        if (user.userId && creditsRedux.newCredit?.id !== 0) dispatch(getCreditRequestsCount());
    }, [creditsRedux.newCredit?.id]);

    return (
        <Box className={classes.rootTab}>
            <Box aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick} style={{display:"flex", alignItems: "center", cursor: "pointer"}}>
                <span style={{color: colorSecondary}}>{creditsAvailable}</span>
				&nbsp;Bundles
                <ExpandMoreIcon color="primary"/>
            </Box>
            <Menu
                id="simple-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
                getContentAnchorEl={null}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
                classes={{
                    list: classes.creditsMenu
                }}
            >
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="space-between"
                    style={{padding: "10px 30px 10px 10px"}}
                >
                    <Typography variant="h3" style={{color: colorSecondary}}>{creditsAvailable}</Typography>
                    <Typography className={classes.creditsMenuTextBold}>Available Appointments</Typography>
                </Box>
                <Box display="flex" justifyContent="center" alignItems="center" style={{borderTop: "1px solid #CCCDE5"}}>
                    <Button
                        variant="text"
                        color="secondary"
                        className={classes.creditsMenuText}
                        style={{
                            height: 45,
                            padding: "0 26px"
                        }}
                        onClick={() => {
                            history.push("/creditSummary");
                            setAnchorEl(null);
                        }}
                    >
						View Bundle Summary
                    </Button>
                </Box>
            </Menu>
        </Box>
    );
};

const setTabs = (user, location) => {
    let isLoggedIn = !!user.userId;
    let TabsArr = [];
    let signUp = location.pathname.includes("login") || location.pathname.includes("signUp") || location.pathname.includes("welcome") || location.pathname.includes("forgotPassword");
    if (signUp === true) {
        TabsArr = TabItems.filter(({id}) => id === 0 || id === 1);
    }
    else {
        TabsArr = TabItems.filter(({id}) => id === 2);
    }
    TabsArr.forEach(tab => {
        switch (tab.id) {
            case 0:
            case 1:
                tab.visible = signUp;
                break;
            default:
                tab.visible = !signUp;
                break;
        }
    });
    return TabsArr;
};

const HeaderTabs: FC<RouteComponentProps> = () => {
    const classes = useStyle();
    const history = useHistory();
    let location = useLocation();
    let isSignUp = location.pathname.includes("login") || location.pathname.includes("signUp") || location.pathname.includes("gettingStarted");
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const [hasSubscription, setHasSubcription] = useState(true);
    const TabsArr = setTabs(user, location);

    useEffect(() => {
        if (user.userId){
            dispatch(getUserByID(user.userId)).then(res => {
                if (res.ownerSubscriptionPlans.length > 0){
                    setHasSubcription(true);
                }else{
                    setHasSubcription(false);
                }
            });
        }
    }, [user.userId]);

    const renderTab = (items: ITab[]): ReactElement[] => {
        const tabs = items.filter(item => item.visible === true).map((item, idx) => {
            const { label, id, src, visible } = item;
            if (visible) {
                if (id === 2) {
                    return (
                        <Link
                            id={`tab_${id}`}
                            key={idx}
                            to="/login"
                            onClick={async () => {
                                localStorage.removeItem("auth");
                                await dispatch(logOutUser());
                                dispatch(setIsLogOut(true));
                                API.clearAuth()
                                history.push("/login");
                            }}
                            className={classes.rootTab}
                        >
                            { label}
                        </Link>);
                }
                return (<Link id={`tab_${id}`} key={idx} to={src} className={classes.rootTab}>{label}</Link>);
            }
        });
        if(user.role === "OWNER" && !isSignUp && !hasSubscription) {
            tabs.splice(2, 0, <MenuLogo key='uniqueKey'/>);
        }
        return tabs;
    };

    return (
        <Box className={classes.rootTabs} >
            { renderTab(TabsArr)}
        </Box>
    );
};

const styleTabs = makeStyles({
    dialogClose: {
        color: colorWhite,
        float: "right"
    },
    rootTab: {
        color: colorWhite,
        minWidth: "auto",
        display: "flex",
        fontWeight: "bold",
        lineHeight: "26px",
        padding: 0,
        margin: 0,
        marginLeft: 24,
        fontSize: 30,
        marginBottom: 50,
        textDecoration: "none"
    },
    dialogContent: {
        display: "flex",
        justifyContent: "center"
    }
});

interface ResponsiveProps extends RouteComponentProps {
	open: boolean,
	handleClose?: Function
}

const ResponsiveTabBar: FC<ResponsiveProps> = ({ open, handleClose, history }: ResponsiveProps) => {
    const classes = styleTabs();
    const location = useLocation();
    const dispatch = useAppDispatch();
    const user = useSelector((state: RootState) => state?.user);
    const TabsArr = setTabs(user, location);
    const renderTab = (items: ITab[]): ReactElement[] => {
        return items.filter(item => item.visible === true).map((item, idx) => {
            const { label, id, src } = item;
            if (item.id === 2) {
                return (<Link
                    id={`tab_${id}`}
                    key={idx}
                    to="/login"
                    className={classes.rootTab}
                    onClick={async () => {
                        localStorage.removeItem("auth");
                        await dispatch(logOutUser());
                        history.push("/login");
                    }}>{label}</Link>);

            }
            return (<Link id={`tab_${id}`} key={idx} to={src} className={classes.rootTab} > {label} </Link>);
        });
    };
    return (
        <Dialog fullScreen open={open} PaperProps={{
            style: {
                backgroundColor: "rgb(88, 88, 88)",
                boxShadow: "none",
                opacity: 0.7
            },
        }}>
            <DialogTitle>
                <IconButton className={classes.dialogClose} onClick={handleClose.bind(null, false)} >
                    < CloseRoundedIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={classes.dialogContent}>
                <Box onClick={handleClose.bind(null, false)}>
                    {renderTab(TabsArr)}
                </Box>
            </DialogContent>
        </Dialog>
    );
};


export default { HeaderTab: withRouter(HeaderTabs), ResponsiveTabBar: withRouter(ResponsiveTabBar) };
